import { render, staticRenderFns } from "./AboutTech.vue?vue&type=template&id=1738a8c1"
import script from "./AboutTech.vue?vue&type=script&lang=js"
export * from "./AboutTech.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports